// Header Flotante - Gestión de scroll y estados
class HeaderFlotante extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = 100; // Píxeles antes de cambiar de estado
    this.lastScrollTop = 0;
    this.isTransparent = this.hasAttribute('transparent');
    this.isSticky = this.hasAttribute('sticky');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Establecer estado inicial
    this.updateScrollState();

    // Listener para scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Listener para resize
    window.addEventListener('resize', () => {
      this.updateHeaderHeight();
    });

    // Actualizar altura inicial
    this.updateHeaderHeight();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Actualizar estado basado en scroll
    this.updateScrollState();

    // Detectar dirección de scroll si es sticky
    if (this.isSticky) {
      if (scrollTop > this.lastScrollTop) {
        this.setAttribute('data-scroll-direction', 'down');
      } else {
        this.setAttribute('data-scroll-direction', 'up');
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateScrollState() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < this.scrollThreshold) {
      this.setAttribute('data-scroll-state', 'top');
    } else {
      this.setAttribute('data-scroll-state', 'scrolled');
    }
  }

  updateHeaderHeight() {
    const height = this.offsetHeight;
    document.documentElement.style.setProperty('--header-flotante-height', `${height}px`);
  }
}

// Registrar el custom element
if (!customElements.get('header-flotante')) {
  customElements.define('header-flotante', HeaderFlotante);
}
